/* PDP: collapse long product descriptions behind a "Lees meer" toggle. */
(() => {
  const description = document.querySelector('.product__description');
  if (!description) return;
  const lineHeight = parseFloat(getComputedStyle(description).lineHeight) || 18;
  if (description.scrollHeight <= lineHeight * 9) return;
  description.classList.add('is-clamped');
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'product__more';
  button.setAttribute('aria-expanded', 'false');
  button.textContent = description.dataset.moreLabel || 'Lees meer';
  button.addEventListener('click', () => {
    const open = description.classList.toggle('is-clamped') === false;
    button.setAttribute('aria-expanded', String(open));
    button.textContent = open ? description.dataset.lessLabel || 'Minder tonen' : description.dataset.moreLabel || 'Lees meer';
  });
  description.after(button);
})();